import React from 'react';
import { Box } from '@material-ui/core';

const TextRenderer = ({
  value
}: any) => <Box>{value}</Box>;

export default TextRenderer;
